module.exports = __webpack_public_path__ + "static/media/lpChange.54b732f6.mp3";